'use client';

import { useLocalStorage } from 'usehooks-ts';

import { initialFilterState } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter.consts';
import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';

const STORAGE_KEY = 'search-filter';

export function useSearchFilter() {
  const [filters, setFilters] = useLocalStorage<Partial<FilterState>>(STORAGE_KEY, initialFilterState);

  return {
    filters,
    setFilters,
  };
}
